export default __webpack_public_path__ + "static/iot2-093da3bfdcb9949e2bf26b094434d854.png";